var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui input"},[_c('input',{attrs:{"disabled":""},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }